import PolicyEditor from './PolicyEditor'

const ReturnRefund = () => (
  <PolicyEditor
    pageName='return-and-refund-policy'
    label='Return, Cancellation & Refund Policy'
    defaults={{
      title: 'Return, Cancellation & Refund Policy',
      subtitle: 'Legal',
    }}
  />
)

export default ReturnRefund
